import { useCallback } from 'react';

import { useListbox } from './ListboxContext';
import ListboxRoot from './ListboxRoot';
import { ListboxDataItem, ListboxInternalProps } from './ListboxTypes';

function ListboxSimple<T>(props: ListboxInternalProps<T>) {
  const { setSelected, selected } = useListbox();
  const triggerSelect = useCallback(
    (item: ListboxDataItem) => {
      setSelected(prev => {
        if (prev.includes(item.value)) {
          return [];
        }
        return [item.value];
      });
    },
    [setSelected]
  );
  return (
    <ListboxRoot
      onSelectItem={triggerSelect}
      noSave={!!selected.length}
      noClean={!!selected.length}
      {...props}
    />
  );
}

export default ListboxSimple;
